import React, { useMemo } from "react";
import { Colors } from "../../../utils/colors";
import { TeamWithScores } from "../../../apis/types";
import { TCText } from "../../../components/tcText/TCText";
import { TeamPlayersProfile } from "./TeamPlayersProfile";
import { TeamPlayerPhoneNumbers } from "./TeamPlayerPhoneNumbers";
import { TeamPlayersAppInstalled } from "./TeamPlayersAppInstalled";
import { useFontDesk } from "../../../context/frontDeskContext";

type props = {
  isCurrentUserTeam?: boolean;
  team?: TeamWithScores;
  isAnyScoreAdded?: boolean;
};

export const TeamPlayer: React.FC<props> = ({
  isCurrentUserTeam,
  team,
  isAnyScoreAdded,
}) => {
  const { isMobile } = useFontDesk();

  const scores = useMemo(() => {
    return (team?.scores?.length ?? 0) > 0
      ? team?.scores
      : [
          {
            score: undefined,
          },
          {
            score: undefined,
          },
          {
            score: undefined,
          },
        ];
  }, [team?.scores]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginTop: 10,
      }}>
      <TeamPlayersProfile
        team={team}
        isCurrentUserTeam={isCurrentUserTeam ?? false}
      />
      {!isMobile ? (
        <TeamPlayerPhoneNumbers
          team={team}
          isCurrentUserTeam={isCurrentUserTeam ?? false}
        />
      ) : null}
      {!isMobile ? (
        <TeamPlayersAppInstalled
          team={team}
          isCurrentUserTeam={isCurrentUserTeam ?? false}
        />
      ) : null}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flex: 1,
          justifyContent: "space-around",
        }}>
        {scores?.map((score) => (
          <div
            style={{
              height: 32,
              width: 32,
              borderRadius: 10,
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(133, 131, 131, 0.1)",
              display: "flex",
            }}>
            <TCText
              value={score?.score?.toString() ?? ""}
              style={{ fontWeight: 600, fontSize: 16, color: Colors.green }}
            />
          </div>
        ))}
        <div
          style={{
            height: 32,
            width: 32,
            borderRadius: 10,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: Colors.success,
            display: "flex",
          }}>
          <TCText
            value={team?.noOfSetsWon?.toString() ?? ""}
            style={{ fontWeight: 600, fontSize: 16, color: Colors.white }}
          />
        </div>
      </div>
    </div>
  );
};
